
import { useState } from 'react';

import PageHeader from '../components/PageHeader';
import Footer from '../components/Footer';

import menu from '../images/menu.gif';
import wifi from '../images/wifi.gif';
import request_item from '../images/request_item.gif';
import assistance from '../images/assitance.gif';
import loyalty from '../images/loyalty.gif';
import feedback from '../images/feedback.gif';
import google from '../images/google_rreview.gif';
import wifi_error from '../images/wifi_error.gif';



import arrow from '../images/arrow.svg';
import OrderStatus from '../components/OrderStatus';


import item_plus from '../images/plus.png';
import item_minus from '../images/minus.png';


export default function Landing() {

     const [itemQuantities, setItemQuantities] = useState({
        spoon: 0,
        fork: 0,
        knife: 0,
        sugar: 0,
        brownSugar: 0,
        whiteSugar: 0
    });

    const [checkedItems, setCheckedItems] = useState({
        spoon: false,
        fork: false,
        knife: false,
        sugar: false,
        brownSugar: false,
        whiteSugar: false
    });

    const increaseQuantity = (item) => {
        setItemQuantities(prev => ({
            ...prev,
            [item]: prev[item] + 1
        }));
    };

    const decreaseQuantity = (item) => {
        setItemQuantities(prev => ({
            ...prev,
            [item]: Math.max(0, prev[item] - 1)
        }));
    };

    const handleCheckboxChange = (item) => {
    setCheckedItems(prev => ({
            ...prev,
            [item]: !prev[item]
        }));
    };

    return(
        <div>
            <PageHeader/>
            <div className="container mb-4">
                <div className="row">

                    {/* order status box */}
                     <OrderStatus/>
                    {/* order status box */}

                    <div className="clearfix"></div>

                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 mb-4">
                        <a href='/menu'>
                            <div className="bg_white rounded p-4 shadow menu_item_card">
                                <img src={menu} alt='' className='d-block mb-3' style={{ width: '100px' }}></img>
                                <h2 className='main_heading mb-3' style={{ color: '#000000' }}>View Menu</h2>
                                <img src={arrow} alt='' className='d-block mb-0' style={{ width: '30px' }}></img>
                            </div>
                        </a>
                    </div>

                    {/* ========== */}

                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 mb-4">
                        <div className="bg_white rounded p-4 shadow menu_item_card" data-bs-toggle="modal" data-bs-target="#choose_wifi_modal">
                            <img src={wifi} alt='' className='d-block mb-3' style={{ width: '100px' }}></img>
                            <h2 className='main_heading mb-3' style={{ color: '#000000' }}>WIFI Password</h2>
                            <img src={arrow} alt='' className='d-block mb-0' style={{ width: '30px' }}></img>
                        </div>
                    </div>

                    {/* ========== */}

                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 mb-4">
                        <div className="bg_white rounded p-4 shadow menu_item_card" data-bs-toggle="modal" data-bs-target="#request_items_modal">
                            <img src={request_item} alt='' className='d-block mb-3' style={{ width: '100px' }}></img>
                            <h2 className='main_heading mb-3' style={{ color: '#000000' }}>Request Items</h2>
                            <img src={arrow} alt='' className='d-block mb-0' style={{ width: '30px' }}></img>
                        </div>
                    </div>

                    {/* ========== */}

                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 mb-4">
                        <div className="bg_white rounded p-4 shadow menu_item_card" data-bs-toggle="modal" data-bs-target="#assistance_modal">
                            <img src={assistance} alt='' className='d-block mb-3' style={{ width: '100px' }}></img>
                            <h2 className='main_heading mb-3' style={{ color: '#000000' }}>Get Assistance</h2>
                            <img src={arrow} alt='' className='d-block mb-0' style={{ width: '30px' }}></img>
                        </div>
                    </div>

                    {/* ========== */}

                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 mb-4">
                        <a href='/registration'>
                            <div className="bg_white rounded p-4 shadow menu_item_card">
                                <img src={loyalty} alt='' className='d-block mb-3' style={{ width: '100px' }}></img>
                                <h2 className='main_heading mb-3' style={{ color: '#000000' }}>Loyalty Registration</h2>
                                <img src={arrow} alt='' className='d-block mb-0' style={{ width: '30px' }}></img>
                            </div>
                        </a>
                    </div>

                    {/* ========== */}

                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 mb-4">
                        <a href='/feedback'>
                            <div className="bg_white rounded p-4 shadow menu_item_card">
                                <img src={feedback} alt='' className='d-block mb-3' style={{ width: '100px' }}></img>
                                <h2 className='main_heading mb-3' style={{ color: '#000000' }}>Give Feedback</h2>
                                <img src={arrow} alt='' className='d-block mb-0' style={{ width: '30px' }}></img>
                            </div>
                        </a>
                    </div>

                    {/* ========== */}

                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 mb-4">
                        <a href='/'>
                            <div className="bg_white rounded p-4 shadow menu_item_card">
                                <img src={google} alt='' className='d-block mb-3' style={{ width: '100px' }}></img>
                                <h2 className='main_heading mb-3' style={{ color: '#000000' }}>Google Review</h2>
                                <img src={arrow} alt='' className='d-block mb-0' style={{ width: '30px' }}></img>
                            </div>
                        </a>
                    </div>

                    {/* ========== */}

                    <div className="clearfix"></div>

                </div>
            </div>

            {/* // assistance modal */}
            <div className="modal fade" id="assistance_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-body text-center">
                        <img src={assistance} alt='' className='d-block mb-3 mx-auto' style={{ width: '100px' }}></img>
                        <h2 className='sub_heading mb-3 text-center' style={{ color: '#000000' }}>ASSISTANCE SUCCESSFULLY <br></br>REQUESTED</h2>

                        <button type="button" className="btn black_btn mb-3" data-bs-dismiss="modal" style={{ width: '130px' }}>OK</button>
                    </div>
                </div>
            </div>
            </div>
            {/* // assistance modal */}

             {/* // Choose Wifi modal */}
            <div className="modal fade" id="choose_wifi_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    {/* close btn */}
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    {/* close btn */}
                    <div className="modal-body text-center">
                        <img src={wifi} alt='' className='d-block mb-3 mx-auto' style={{ width: '100px' }}></img>
                        <h2 className='sub_heading mb-3 text-center' style={{ color: '#000000' }}>WIFI PASSWORD</h2>
                        <p>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                        </p>
                        <div className="text-center">
                            <button type="button" className="btn d-block black_btn mb-3 m-auto" style={{ width: '200px' }} data-bs-toggle="modal" data-bs-target="#password_wifi_modal">NORMAL SPEED</button>
                            <button type="button" className="btn d-block black_btn mb-3 m-auto" style={{ width: '200px' }} data-bs-toggle="modal" data-bs-target="#error_wifi_modal">HIGH SPEED</button>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            {/* // Choose Wifi modal */}

             {/* // error Wifi modal */}
            <div className="modal fade" id="error_wifi_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-body text-center">
                        <img src={wifi_error} alt='' className='d-block mb-3 mx-auto' style={{ width: '100px' }}></img>
                        <h2 className='sub_heading mb-3 text-center' style={{ color: '#000000' }}>Oops...!</h2>
                        <p>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                        </p>
                        <div className="text-center">
                            <button type="button" className="btn d-block black_btn mb-3 m-auto" data-bs-dismiss="modal" aria-label="Close" style={{ width: '200px' }}>GOT IT</button>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            {/* // error Wifi modal */}

            {/* // password Wifi modal */}
            <div className="modal fade" id="password_wifi_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    {/* close btn */}
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    {/* close btn */}
                    <div className="modal-body text-center">
                        <img src={wifi} alt='' className='d-block mb-3 mx-auto' style={{ width: '100px' }}></img>
                        <h2 className='sub_heading mb-3 text-center mb-4' style={{ color: '#000000' }}>WIFI PASSWORD</h2>

                        <h2 className='sub_heading mb-3 text-center orange_text'>SSID 01: First_floor-1</h2>
                        <div className="d-flex justify-content-center mb-4">
                             <h2 className='sub_heading mb-3 text-center border rounded p-3 me-2' style={{ color: '#000000' }}>BARISTA@P123</h2>
                             <button type="button" className="btn black_btn mb-3" style={{ width: '100px' }}>COPY</button>
                        </div>

                        {/* ========== */}

                        <h2 className='sub_heading mb-3 text-center orange_text'>SSID 02: First_floor-2</h2>
                        <div className="d-flex justify-content-center mb-4">
                             <h2 className='sub_heading mb-3 text-center border rounded p-3 me-2' style={{ color: '#000000' }}>BARISTA@P123</h2>
                             <button type="button" className="btn black_btn mb-3" style={{ width: '100px' }}>COPY</button>
                        </div>

                        {/* ========== */}

                    </div>
                </div>
            </div>
            </div>
            {/* // password Wifi modal */}


             {/* // request items modal */}
            {/* request items modal */}
                    <div className="modal fade" id="request_items_modal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                <div className="modal-body text-center">
                                    <img src={request_item} alt='' className='d-block mb-3 mx-auto' style={{ width: '100px' }} />
                                    <h2 className='sub_heading mb-0 text-center' style={{ color: '#000000' }}>REQUEST ITEMS</h2>
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>

                                    {/* Spoon */}
                                    <ItemRow 
                                        label="spoon" 
                                        name="spoon" 
                                        value={itemQuantities.spoon} 
                                        onIncrease={increaseQuantity} 
                                        onDecrease={decreaseQuantity}
                                        isChecked={checkedItems.spoon}
                                        onCheckboxChange={handleCheckboxChange}
                                    />

                                    {/* Fork */}
                                    <ItemRow 
                                        label="Fork" 
                                        name="fork" 
                                        value={itemQuantities.fork} 
                                        onIncrease={increaseQuantity} 
                                        onDecrease={decreaseQuantity}
                                        isChecked={checkedItems.fork}
                                        onCheckboxChange={handleCheckboxChange} 
                                    />

                                    {/* Knife */}
                                    <ItemRow 
                                        label="Knife" 
                                        name="knife" 
                                        value={itemQuantities.knife} 
                                        onIncrease={increaseQuantity} 
                                        onDecrease={decreaseQuantity}
                                        isChecked={checkedItems.knife}
                                        onCheckboxChange={handleCheckboxChange}
                                    />

                                    {/* Sugar */}
                                    <ItemRow 
                                        label="Sugar" 
                                        name="sugar" 
                                        value={itemQuantities.sugar} 
                                        onIncrease={increaseQuantity} 
                                        onDecrease={decreaseQuantity}
                                        isChecked={checkedItems.sugar}
                                        onCheckboxChange={handleCheckboxChange}
                                        showAddBox={false}
                                    />

                                    {/* Conditionally render Brown/White Sugar if Sugar is checked */}
                                    {checkedItems.sugar && (
                                        <>
                                            <ItemRow 
                                                label="Brown Sugar" 
                                                name="brownSugar" 
                                                value={itemQuantities.brownSugar} 
                                                onIncrease={increaseQuantity} 
                                                onDecrease={decreaseQuantity}
                                                isChecked={checkedItems.brownSugar}
                                                onCheckboxChange={handleCheckboxChange}
                                                indentLeft={true}
                                            />

                                            <ItemRow 
                                                label="White Sugar" 
                                                name="whiteSugar" 
                                                value={itemQuantities.whiteSugar} 
                                                onIncrease={increaseQuantity} 
                                                onDecrease={decreaseQuantity}
                                                isChecked={checkedItems.whiteSugar}
                                                onCheckboxChange={handleCheckboxChange}
                                                indentLeft={true}
                                            />
                                        </>
                                    )}

                                    <div className="col-12 text-center mt-4">
                                        <button type="button" className="btn d-block black_btn mb-3 m-auto" style={{ width: '200px' }}>REQUEST</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
             {/* // request items modal */}

            <Footer/>
        </div>
    );
};


function ItemRow({ 
    label, 
    name, 
    value, 
    onIncrease, 
    onDecrease, 
    isChecked, 
    onCheckboxChange, 
    showAddBox = true, 
    indentLeft = false
}) {
    return (
        <div className={`require_item_div d-flex justify-content-between align-items-center ${indentLeft ? 'ps-4' : ''}`}>
            <div className="checkbox">
                <label style={{ fontSize: '18px' }}>
                    <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={() => onCheckboxChange(name)}
                    />
                    <span className="cr"><i className="cr-icon fa fa-check"></i></span>
                    {label}
                </label>
            </div>

            {/* Conditionally show add_box only if showAddBox is true and the item is checked */}
            {isChecked && showAddBox && (
                <div className="add_box">
                    <div className="input-row">
                        <div className="input gap-1">
                            <button className="minus" onClick={() => onDecrease(name)} aria-label="Decrease by one">
                                <img src={item_minus} alt='' className='d-block mx-auto mb-0' style={{ width: '18px' }} />
                            </button>
                            <div className="number">{value}</div>
                            <button className="plus" onClick={() => onIncrease(name)} aria-label="Increase by one">
                                <img src={item_plus} alt='' className='d-block mx-auto mb-0' style={{ width: '18px' }} />
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}


